import { defineNuxtPlugin, useState } from "nuxt/app";
import { readonly } from "vue";
import type { SalesChannel } from "#imports";

export default defineNuxtPlugin(() => {
  const activeSalesChannel = useState<SalesChannel | undefined>(
    "active-sales-channel",
  );

  const setActiveSalesChannel = (channel: SalesChannel) => {
    activeSalesChannel.value = channel;
  };

  return {
    provide: {
      layoutManager: {
        setActiveSalesChannel,
        activeSalesChannel: readonly(activeSalesChannel),
      },
    },
  };
});
